import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// --- Cache busting on new deployments ---
const BUILD_VERSION = process.env.REACT_APP_BUILD_VERSION || "dev";
const STORED_VERSION_KEY = "gutful_build_version";

const storedVersion = localStorage.getItem(STORED_VERSION_KEY);

if (BUILD_VERSION !== "dev" && storedVersion !== BUILD_VERSION) {
  // Preserve auth data before clearing
  const authKeys = ["gutful_token", "gutful_user", "gutful_auth_expiry"];
  const savedAuth = {};
  authKeys.forEach((key) => {
    const value = localStorage.getItem(key);
    if (value) savedAuth[key] = value;
  });

  // New build detected — clear all caches
  localStorage.clear();
  sessionStorage.clear();

  // Restore auth data so user stays logged in
  Object.entries(savedAuth).forEach(([key, value]) => {
    localStorage.setItem(key, value);
  });

  // Clear Cache API (used by service workers / browser caches)
  if ("caches" in window) {
    caches.keys().then((names) => {
      names.forEach((name) => caches.delete(name));
    });
  }

  // Store the new version AFTER clearing
  localStorage.setItem(STORED_VERSION_KEY, BUILD_VERSION);

  // Hard reload to fetch fresh assets (bypasses browser cache)
  window.location.reload(true);
} else {
  // First visit or same build — just store the version
  localStorage.setItem(STORED_VERSION_KEY, BUILD_VERSION);

  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
